/**
 * Subscription widget — one-time vs. Abo (native Shopify selling plans / Recharge).
 *
 * Pairs with snippets/subscription-widget.liquid (rendered inside .pdp-form, above the ATC).
 * Loaded AFTER product-form.js, so on a variant change product-form.js runs first
 * (updates #variant-id + the one-time main price) and this script runs second to
 * re-apply the subscription override when "Im Abo" is active.
 *
 * Responsibilities (no money math — all price strings are pre-formatted server-side):
 *   - toggle the active card (CSS :checked handles the visual; class is a fallback)
 *   - write the chosen selling_plan id into <input name="selling_plan"> ("" = one-time)
 *   - mirror the per-delivery price / Grundpreis into the main price block when Abo is active
 *   - swap the ATC label (In den Warenkorb ↔ Abo in den Warenkorb)
 *   - keep the subscribe card + interval <select> correct across variant (size) changes
 *   - announce changes via a visually-hidden live region
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-purchase-options]');
  if (!root) return;

  var island = {};
  var dataEl = root.querySelector('[data-selling-plan-data]');
  if (dataEl) { try { island = JSON.parse(dataEl.textContent); } catch (e) { island = {}; } }

  /* ── Widget elements ── */
  var radios        = root.querySelectorAll('input[name="purchase_option"]');
  var cards         = root.querySelectorAll('.purchase-option');
  var otCardPrice   = root.querySelector('.purchase-option--onetime .purchase-option__price');
  var subPrice      = root.querySelector('[data-subscribe-price]');
  var subRef        = root.querySelector('.purchase-option__price-ref');
  var subBadge      = root.querySelector('.purchase-option__badge');
  var intervalSel   = root.querySelector('[data-interval-select]');
  var intervalStat  = root.querySelector('[data-interval-static]');
  var planInput     = root.querySelector('[data-selling-plan-input]');
  var statusEl      = root.querySelector('[data-purchase-status]');

  var atcOnetime   = root.getAttribute('data-atc-onetime')   || 'In den Warenkorb';
  var atcSubscribe = root.getAttribute('data-atc-subscribe') || 'Abo in den Warenkorb';
  var tplOnetime   = root.getAttribute('data-status-onetime')   || '';
  var tplSubscribe = root.getAttribute('data-status-subscribe') || '';

  /* ── PDP buy-box elements (outside the widget) ── */
  var container   = root.closest('.pdp-hero') || document;
  var mainPrice   = container.querySelector('[data-product-price]');
  var mainUnit    = container.querySelector('[data-unit-price]');
  var atcText     = container.querySelector('[data-add-to-cart-text]');
  var atcBtn      = container.querySelector('.pdp-add-to-cart');
  var variantHidden = container.querySelector('#variant-id');
  var variantInputs = container.querySelectorAll('input[name="variant-select"]');

  /* ── One-time snapshot of the main price block (so we can restore it) ── */
  var otHtml = mainPrice ? mainPrice.innerHTML : '';
  var otUnitText = mainUnit ? mainUnit.textContent : '';
  var otUnitDisplay = mainUnit ? mainUnit.style.display : '';
  function snapshotOnetime() {
    if (mainPrice) otHtml = mainPrice.innerHTML;
    if (mainUnit) { otUnitText = mainUnit.textContent; otUnitDisplay = mainUnit.style.display; }
  }

  /* ── Helpers ── */
  function currentVariantId() {
    var raw = variantHidden ? variantHidden.value : '';
    return String(raw || '');
  }
  function variantEntry() {
    var id = currentVariantId();
    return (island && island[id]) ? island[id] : null;
  }
  function plansFor() {
    var e = variantEntry();
    return (e && e.plans && e.plans.length) ? e.plans : [];
  }
  function selectedIndex() {
    if (intervalSel) return Math.max(0, intervalSel.selectedIndex);
    return 0;
  }
  function selectedPlan() {
    var plans = plansFor();
    if (!plans.length) return null;
    var i = selectedIndex();
    return plans[i] || plans[0];
  }
  function isSubscribe() {
    var r = root.querySelector('input[name="purchase_option"]:checked');
    return !!(r && r.value === 'subscribe');
  }

  function setActiveCards() {
    for (var i = 0; i < cards.length; i++) {
      var input = cards[i].querySelector('input[name="purchase_option"]');
      cards[i].classList.toggle('active', !!(input && input.checked));
    }
  }

  function setAtcLabel(text) {
    /* Never overwrite the sold-out label (button disabled by product-form.js). */
    if (atcText && atcBtn && !atcBtn.disabled) atcText.textContent = text;
  }

  function announce(text) {
    if (statusEl) statusEl.textContent = text || '';
  }

  function setMainSubscribe(plan) {
    if (mainPrice && plan) {
      mainPrice.innerHTML = '<span class="pdp-price--sub">' + plan.price + '</span>';
    }
    if (mainUnit) {
      if (plan && plan.unit) { mainUnit.textContent = plan.unit; mainUnit.style.display = ''; }
      else { mainUnit.style.display = 'none'; }
    }
  }
  function restoreMainOnetime() {
    if (mainPrice) mainPrice.innerHTML = otHtml;
    if (mainUnit) { mainUnit.textContent = otUnitText; mainUnit.style.display = otUnitDisplay; }
  }

  /* Refresh the subscribe card + interval control + one-time card price for the active variant. */
  function refreshForVariant() {
    var entry = variantEntry();
    var plans = plansFor();
    if (!entry || !plans.length) return;

    if (otCardPrice) otCardPrice.textContent = entry.ot;
    if (subRef) subRef.textContent = entry.ot;

    /* Rebuild interval options (count/order is stable across variants — keep the index). */
    if (intervalSel) {
      var keep = Math.min(intervalSel.selectedIndex < 0 ? 0 : intervalSel.selectedIndex, plans.length - 1);
      intervalSel.innerHTML = '';
      for (var i = 0; i < plans.length; i++) {
        var opt = document.createElement('option');
        opt.value = plans[i].id;
        opt.textContent = plans[i].name;
        intervalSel.appendChild(opt);
      }
      intervalSel.selectedIndex = keep;
    } else if (intervalStat) {
      intervalStat.textContent = plans[0].name;
      intervalStat.setAttribute('data-plan-id', plans[0].id);
    }

    applyPlanToCard(selectedPlan());
  }

  /* Write a plan's price/unit/badge into the subscribe card. */
  function applyPlanToCard(plan) {
    if (!plan) return;
    if (subPrice) subPrice.textContent = plan.price;
    if (subBadge && typeof plan.percent !== 'undefined') {
      subBadge.textContent = '-' + plan.percent + '%';
    }
  }

  function planId() {
    var plan = selectedPlan();
    if (plan && plan.id) return plan.id;
    if (intervalStat) return intervalStat.getAttribute('data-plan-id') || '';
    return '';
  }

  /* Apply the current purchase mode to the buy box. */
  function applyMode() {
    setActiveCards();
    var entry = variantEntry();
    if (isSubscribe()) {
      var plan = selectedPlan();
      if (planInput) planInput.value = planId();
      setMainSubscribe(plan);
      setAtcLabel(atcSubscribe);
      if (plan) {
        announce(tplSubscribe.replace('%PRICE%', plan.price).replace('%PERCENT%', plan.percent));
      }
    } else {
      if (planInput) planInput.value = '';
      restoreMainOnetime();
      setAtcLabel(atcOnetime);
      announce(tplOnetime.replace('%PRICE%', entry ? entry.ot : (otCardPrice ? otCardPrice.textContent : '')));
    }
  }

  /* ── Events ── */
  for (var i = 0; i < radios.length; i++) {
    radios[i].addEventListener('change', applyMode);
  }

  if (intervalSel) {
    intervalSel.addEventListener('change', function () {
      applyPlanToCard(selectedPlan());
      if (isSubscribe()) applyMode();
    });
  }

  /* Variant (size) change — runs AFTER product-form.js reset the one-time price. */
  for (var v = 0; v < variantInputs.length; v++) {
    variantInputs[v].addEventListener('change', function () {
      /* Defer one tick so product-form.js has finished writing the one-time price/label. */
      window.setTimeout(function () {
        snapshotOnetime();
        refreshForVariant();
        applyMode();
      }, 0);
    });
  }

  /* ── Init ── */
  snapshotOnetime();
  refreshForVariant();
  applyMode();
})();
